export default {
  title: 'Nueva Actividad Dinámica',
  title_edit: 'Editando Actividad Dinámica',

  //sections ___________________________________
  generalSectionName: 'Nombre*',
  generalSectionChecklist: 'Cuestionario*',
  generalSectionType: 'Tipo del destino',
  generalSectionLevel: 'Nivel del destino',
  generalSectionPlace: 'Destino',
  generalSectionDescription: 'Descripción*',

  themeSectionTitle: 'Tema',
  themeLogo: 'Logo',
  themeColor: 'Color',

  redirectionSection: 'Redireccionamiento',
  redirectionLabel: 'Al responder, redirigir a ejecución',

  completionSection: 'Configuraciones de finalización',
  completionTitleMessage: 'Título del mensaje de conclusión',
  completionBodyMessage: 'Cuerpo del mensaje de conclusión'
}
